import React from "react";
import { BRAND_ASSETS } from "@/lib/brandAssets";

/**
 * Decorative floating shapes — used as backdrop sprinkles on mid-page sections.
 * Pure CSS animations, no JS, no event listeners. Set `variant` to pick a
 * preset placement.
 */
export default function FloatingShapes({ variant = "left", className = "" }) {
  const shapes = variant === "right"
    ? [
        { src: BRAND_ASSETS.hexagonWhite, cls: "top-[8%] right-[6%] w-[120px] opacity-30 animate-kb-float", delay: "0s" },
        { src: BRAND_ASSETS.kShapePurple, cls: "bottom-[12%] right-[3%] w-[68px] opacity-30 animate-kb-drift", delay: "0.4s" },
        { src: BRAND_ASSETS.hexGroupGrey, cls: "top-[40%] right-[15%] w-[140px] opacity-25 animate-kb-drift", delay: "0.8s" },
      ]
    : variant === "scattered"
    ? [
        { src: BRAND_ASSETS.kShapePurple, cls: "top-[6%] left-[8%] w-[70px] opacity-35 animate-kb-float", delay: "0s" },
        { src: BRAND_ASSETS.hexagonWhite, cls: "top-[20%] right-[12%] w-[110px] opacity-25 animate-kb-drift", delay: "0.5s" },
        { src: BRAND_ASSETS.oGlassPurple, cls: "bottom-[14%] left-[10%] w-[90px] opacity-30 animate-kb-float", delay: "1.1s" },
        { src: BRAND_ASSETS.hexGroupGrey, cls: "bottom-[10%] right-[6%] w-[150px] opacity-25 animate-kb-drift", delay: "0.3s" },
      ]
    : [
        { src: BRAND_ASSETS.hexGroup, cls: "top-[10%] left-[4%] w-[180px] opacity-30 animate-kb-drift", delay: "0s" },
        { src: BRAND_ASSETS.kShapePurple, cls: "bottom-[15%] left-[7%] w-[68px] opacity-40 animate-kb-float", delay: "0.6s" },
        { src: BRAND_ASSETS.oGlassPurple, cls: "top-[60%] right-[8%] w-[80px] opacity-35 animate-kb-drift", delay: "1.2s" },
      ];

  return (
    <div aria-hidden="true" className={`absolute inset-0 overflow-hidden pointer-events-none ${className}`}>
      {shapes.map((s, i) => (
        <img
          key={i}
          src={s.src}
          alt=""
          draggable="false"
          className={`absolute select-none ${s.cls} hidden md:block`}
          style={{ animationDelay: s.delay }}
        />
      ))}
    </div>
  );
}
